import { Typography, Box } from "@mui/material";
import JsonEditorAce from "../../../components/code/ace/json.editor";
import { useEffect, useState } from "react";
import TemplateEditorAce from "../../../components/code/ace/template.editor";
import { Create, FileField, List, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput, useDataProvider, useRecordContext } from "react-admin";
import DataGridExtended from "../../../components/list/data.grid.extended";
import { useAppDataContext } from "../../../framework/app/app.data.context";
import FileInput from "../../../components/file/FileInput";
import { getConfig } from "../../../framework/config/app.config";

const csApiUrl = getConfig('VITE_BASE_URL');

export const AIFileStoreList = (props) => (
  <List {...props} resource="aifilestore" actions={null}>
    <DataGridExtended rowClick="edit" title={"Files"}>
      <TextField label="Name" source="name" />
    </DataGridExtended>
  </List>
);

export const AIFileStoreShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
      </SimpleShowLayout>
    </Show>
  );
};

export const AIFileStoreCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput label="Name" source="name" />
      <TextInput label="Description" source="description" />
      <FileInput multiple source="files" label="Upload File" accept="">
        <FileField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  </Create>
);

